/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddFittingTabComponent } from './add-fitting-tab.component';
import { SysqueTabModule } from '../../../../../../shared/ui/src/lib/components/sysque-tab';
import { CurateSearchModule } from './curate-search/curate-search.module';
import { FittingTreeViewModule } from './fitting-tree-view/fitting-tree-view.module';

@NgModule({
  declarations: [AddFittingTabComponent],
  imports: [CommonModule, SysqueTabModule, CurateSearchModule, FittingTreeViewModule],
  exports: [AddFittingTabComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AddFittingTabModule {}
